import $ from 'jquery'
import * as Screen from '../modules/checkScreen'
import {
  setCookie,
  getCookie,
  checkCookie,
} from '../modules/cookie'

const LOADED_CLASS = '-is-loaded'

const cloneArticleCard = () => {
  const $target = $('.js-card-article')
  const CLONE_CLASS = '-is-clone'
  const LEFT_CLASS = '-clone-left'
  const RIGHT_CLASS = '-clone-right'

  if (!$target.length) {
    return
  }

  $target.each((index, el) => {
    const $wrapper = $(el).parent()
    const className = $(el).attr('class')
    const $cloneLeft = $('<div />', {
      class: `${className} ${CLONE_CLASS} ${LEFT_CLASS}`,
      html: $(el).html()
    })
    const $cloneRight = $('<div />', {
      class: `${className} ${CLONE_CLASS} ${RIGHT_CLASS}`,
      html: $(el).html()
    })

    $wrapper.append($cloneLeft, $cloneRight)
  })
}

let isLockedTimeout = null

function removeClassLocked() {
  isLockedTimeout = setTimeout(() => {
    if ($('html').hasClass('-is-locked')) {
      $('html').removeClass('-is-locked')
      clearTimeout(isLockedTimeout)
    } else {
      removeClassLocked()
    }
  }, 100)
}

const checkIntroDone = () => {
  if (checkCookie('splash-screen') === '') {
    if (Screen.isPC()) {
      $('html head').append('<script src="/assets/js/PC_Intro.js"></script>')
    } else {
      $('html head').append('<script src="/assets/js/SP_Intro.js"></script>')
    }

    setCookie('splash-screen', 1, 1)
  } else {
    $(document).find('.intro').remove()
    removeClassLocked()
  }
}

const initTop = () => {
  checkIntroDone()
  cloneArticleCard()
}

export default initTop
